module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/aT2hiR/tc-custom/9780292786691.jpg?1704276800489",
      "alt": "This image is the cover for the book Texas Rangers, Texas Classics"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Texas Rangers, Texas Classics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The renowned historian’s classic study of the Texas Ranger Division, presented with its original illustrations and a foreword by Lyndon B. Johnson.")]), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Texas Rangers")]), _vm._v(" tells the story of this unique law enforcement agency from its origin in 1823, when it was formed by “Father of Texas” Stephen F. Austin, to the 1930s, when legendary lawman Frank Hamer tracked down the infamous outlaws Bonnie and Clyde. Both colorful and authoritative, it presents the evolution and exploits of the Texas Rangers through Comanche raids, the Mexican War, annexation, secession, and on into the 20th century."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Written in 1935 by Walter Prescott Webb, the pioneering historian of the American West, "), _c('i', [_vm._v("Texas Rangers")]), _vm._v(" is a true classic of Texas history.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Walter Prescott Webb, Lyndon B. Johnson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Walter Prescott Webb (1888–1963) was a historian of the American West.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Texas Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0